import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../../../reducers';
import { Api } from '../../../typings/api';
import DriveItemUtils, { ResolutionDisplayType } from '../../../utils/driveItem';
import SelectionToggler from '../../Selection/Toggler';
import { StyledTheaterFooter, Extension, Label, ActionIcons, DownloadButton } from './styles';
import UserAgentUtils from '../../../utils/userAgent';
import StatsUtils from '../../../utils/statistics';
import { DownloadMode } from '../../../containers/DownloadManager/reducer';
import { requestWebDownloadItem, requestMobileAppDownload } from '../../../containers/DownloadManager/actions';
import Utils from '../../../utils';

export interface TheaterFooterProps {
	driveItem: Api.DriveItem;
	isDownloadable: boolean;
	dispatch: Dispatch<StoreState>;
}

const TheaterFooter = ({ driveItem, isDownloadable, dispatch }: TheaterFooterProps) => {
	const extension = DriveItemUtils.getExtension(driveItem);
	const label = DriveItemUtils.getDisplayName(driveItem);

	const handleDownloadClick = () => {
		const { isMobileApp } = UserAgentUtils;

		StatsUtils.trackDownload([driveItem]);

		if (!isMobileApp) {
			dispatch(requestWebDownloadItem(driveItem));
		} else {
			dispatch(requestMobileAppDownload(driveItem, DownloadMode.Requested));
		}
	};

	return (
		<StyledTheaterFooter>
			<Extension>{extension}</Extension>
			<Label>{label}</Label>
			<ActionIcons>
				{isDownloadable &&
					<DownloadButton
						type="button"
						onClick={handleDownloadClick}
					>
						{Utils.getSvgIcon('iconset_uprez_download_bold')}
					</DownloadButton>
				}
				<SelectionToggler
					itemId={driveItem.id}
					displayMode={ResolutionDisplayType.Theater}
				/>
			</ActionIcons>
		</StyledTheaterFooter>
	);
};

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		galleryInfos: { template: { sharedMethods } },
		downloadManager,
	} = state;

	return {
		downloadManager,
		sharedMethods,
		isDownloadable: DriveItemUtils.isDownloadable(ownProps.driveItem, downloadManager, sharedMethods),
	};
};

export default connect(mapStateToProps)(TheaterFooter);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Theater/Footer/index.tsx